<template>
    <sa-page-layout :btnSaveVisible="true" :pathResource="pathResource" :data="documentoJsonData"
        :btnRouterBackVisible="true" @beforeSave="onBeforeSave" @afterSave="onAfterSave">
        <!-- <template slot="toolbar"> <b-alert show>Default Alert</b-alert> </template> -->
        <template slot="toolbar">
            <b-button v-if="isBtnDocumentiCollegatiVisibile" :disabled="isBtnDocumentiCollegatiDisabled"
                variant="purple btn-toolbar float-sm-left sa-margin-left" style="margin-right: 5px" size="sm"
                @click="onClickDocumentiCollegati"><b-icon icon="check2"></b-icon>Documenti Collegati</b-button>
        </template>
        <template slot="table-header">
            <!-- <div class="sa-documento-meta-wrapper" v-if="id != '-1' && id != null">
                <div class="sa-documento-meta-item">
                    <div class="sa-documento-meta-icon-wrapper create">
                        <b-icon icon="plus-circle-fill"></b-icon>
                    </div>
                    <div class="sa-documento-meta-text">
                        <span class="sa-documento-meta-label">Registrazione</span>
                        <span class="sa-documento-meta-date">{{ formatDateTime(documentoJsonData.createDate) }}</span>
                    </div>
                </div>
            </div> -->
            <div class="sa-documento-meta-wrapper" v-if="id != '-1' && id != null">
                <div class="sa-documento-meta-item">
                    <div class="sa-documento-meta-icon-wrapper update">
                        <b-icon icon="pencil-fill"></b-icon>
                    </div>
                    <div class="sa-documento-meta-text">
                        <span class="sa-documento-meta-label">Ultima Modifica</span>
                        <span class="sa-documento-meta-date">{{ formatDateTime(documentoJsonData.updateDate) }}</span>
                    </div>
                </div>
            </div>
            <contabilita-documento-dati-edit-compontent ref="cmpContabilitaDocumentoDatiEditCompontent"
                @update="onUpdateContabilitaDocumentoDatiEditCompontent" />
        </template>
        <template slot="table-body">
            <b-tabs content-class="mt-3" class="sa-tab" style="height: 100%" fill @input="onInputTabs">
                <b-tab title="Righe Documento" active>

                    <contabilita-documento-righe-component :jsonData="documentoJsonData"
                        @update="onUpdateContabilitaRigheDocumento" ref="cmpContabilitaDocumentoRigheComponent" />
                </b-tab>
                <b-tab title="Riepilogo" :disabled="documentoJsonData.righeDocumento == 0">
                    <contabilita-riepilogo-component ref="cmpContabilitaDocumentoRiepologoComponent" />
                </b-tab>

                <!-- :disabled="isDocumentiCollegatiDisabled()" -->
                <b-tab v-if="isBtnDocumentiCollegatiVisibile" :disabled="isBtnDocumentiCollegatiDisabled"
                    title="Documenti Collegati">
                    <ContabilitaDocumentiCollegatiComponent ref="cmpContabilitaDocumentiCollegatiComponent" />
                </b-tab>
            </b-tabs>
        </template>
        <template slot="table-footer">
            <contabilita-documenti-collegati-modal @updateDocumentiRiferimento="onUpdateDocumentiRiferimento"
                ref="mdlContabilitaDocumentiCollegatiModal" />
            <div class="sa-contabilita-footer-totali d-flex justify-content-between align-items-center">
                <div class="small">
                    Imponibile: <span class="font-weight-bold">{{ imponibile.toFixed(2) }} €</span>
                </div>
                <div class="small">
                    IVA: <span class="font-weight-bold">{{ iva.toFixed(2) }} €</span>
                </div>
                <div class="h5 mb-0">
                    TOTALE: <span class="sa-contabilita-total-amount">{{ totale.toFixed(2) }} €</span>
                </div>
            </div>
            <!-- <div style="padding: 5px">
				<b-row class="text-center">
					<b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
						<span class="sa-label-data"><b>Totale Imponibile: </b>{{ documentoJsonData.documentoTotaleImponibile.toLocaleString("it-IT", { style: "currency", currency: "EUR" }) }}</span>
					</b-col>
					<b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
						<span class="sa-label-data"><b>Totale Imposta.: </b> {{ documentoJsonData.documentoTotaleImposta.toLocaleString("it-IT", { style: "currency", currency: "EUR" }) }}</span>
					</b-col>
					<b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
						<span class="sa-label-data"
							><b>Totale Documento: </b>
							{{
								documentoJsonData.documentoTotale.toLocaleString("it-IT", {
									style: "currency",
									currency: "EUR",
								})
							}}</span
						>
					</b-col>
				</b-row>
			</div> -->
        </template>
    </sa-page-layout>
</template>
<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import StruttureMixin from "../../strutture/mixins/StruttureMixin";
import UtilityMixin from "../../utility/UtilityMixin.js";
import ContabilitaDocumentoDatiEditCompontent from "../components/ContabilitaDocumentoDatiEditCompontent.vue";
import ContabilitaDocumentoRigheComponent from "../components/ContabilitaDocumentoRigheEditComponent.vue";
import ContabilitaRiepilogoComponent from "../components/ContabilitaRiepilogoComponent.vue";
import ContabilitaDocumentiCollegatiModal from "../components/ContabilitaDocumentiCollegatiModal.vue";
import ContabilitaDocumentiCollegatiComponent from "../components/ContabilitaDocumentiCollegatiComponent.vue";
import ContabilitaMixin from "../mixins/ContabilitaMixin";
import MagazzinoMixins from "../../magazzino/mixins/MagazzinoMixins";
//import DatePicker from "vue2-datepicker";
export default {
    components: { SaPageLayout, ContabilitaDocumentoDatiEditCompontent, ContabilitaDocumentoRigheComponent, ContabilitaDocumentiCollegatiComponent, ContabilitaRiepilogoComponent, ContabilitaDocumentiCollegatiModal },
    mixins: [UtilityMixin, StruttureMixin, ContabilitaMixin, MagazzinoMixins],
    data() {
        return {
            id: "-1",
            pathResourceCalcoloDocumento: "/contabilitadocumenti/calcola",
            pathResource: "/contabilitadocumenti",
            pathResourceContabilitaCausaleDocumento: "/contabilitadocumentocausali/",
            causaleSelezionata: null,
            keyRigheDocumento: 0,
            isBtnDocumentiCollegatiVisibile: false,
        };
    },
    computed: {
        isBtnDocumentiCollegatiDisabled: function () {
            if (this.documentoJsonData.soggettoId == null || this.documentoJsonData.soggettoId == "-1" || this.documentoJsonData.soggettoCognomeRagione == null || this.documentoJsonData.soggettoNome == null) {
                return true;
            }
            return false;
        },
        isMagazzinoObbligatorio: function () {
            if (this.documentoJsonData.causaleDocumentoOperazioneMagazzino != null && this.documentoJsonData.causaleDocumentoOperazioneMagazzino != 0 && this.documentoJsonData.magazzinoId == null) {
                return true;
            }
            return false;
        },
        imponibile() {
            //return this.righe.reduce((acc, r) => acc + r.qta * r.prezzo, 0);
            return 0;
        },
        iva() {
            //return this.righe.reduce((acc, r) => acc + r.qta * r.prezzo * (r.aliquota / 100), 0);
            return 0;
        },
        totale() {
            return this.imponibile + this.iva;
        },
    },
    watch: {
        "documentoJsonData.causaleDocumentoId": function (params) {
            this.loadDataCausale(params);
        },
    },
    mounted() {
        this.id = this.$route.params.id;
        if (this.id && this.id != "-1") {
            this.loadData();
        }
        this.init();
    },
    methods: {
        init() {
            this.$refs.cmpContabilitaDocumentoDatiEditCompontent.init(this.documentoJsonData);
            this.$refs.cmpContabilitaDocumentoRigheComponent.init(this.documentoJsonData);
            this.$refs.cmpContabilitaDocumentoRiepologoComponent.init(this.documentoJsonData);
        },
        onBeforeSave() {
            this.mangazzinoArticoliUnitaMisuraLoadData();
            this.prepareJsonData();

        },
        onAfterSave() {
            this.$router.push("/contabilita/documenti")

        },
        onUpdateContabilitaDocumentoDatiEditCompontent(jsonData) {
            this.documentoJsonData = { ...jsonData };
        },
        onInputTabs(value) {
            switch (value) {
                case 0:
                    this.$refs.cmpContabilitaDocumentoRigheComponent.init(this.documentoJsonData);
                    break;
                case 1:
                    break;
                case 2:
                    this.$refs.cmpContabilitaDocumentiCollegatiComponent.init(this.documentoJsonData, this.causaleSelezionata);
                    break;
                default:
                    break;

            }
        },
        onUpdateContabilitaRigheDocumento(righeDocumento) {
            this.documentoJsonData.righeDocumento = [...righeDocumento];
            this.calcolaDocumentoRigaDocumento();

        },
        calcolaDocumentoRigaDocumento() {
            let link = process.env.VUE_APP_PATH_API + this.pathResourceCalcoloDocumento;
            this.prepareJsonData();
            UtilityMixin.methods.restCallPost(link, this.documentoJsonData, this.calcolaDocumentoRigaDocumentoSuccess, this.calcolaDocumentoRigaDocumentoError);
        },
        prepareJsonData() {
            delete this.documentoJsonData._showDetails;
            this.documentoJsonData.righeDocumento.forEach((e) => {





                delete e._showDetails;
                delete e.totaleRiga;
                e.sconto = e.sconto / 100;
                if (e.lottiScadenze.length > 0) {
                    e.lottiScadenze.forEach((e) => {
                        delete e.giacenza
                    });
                }
            });
        },
        calcolaDocumentoRigaDocumentoSuccess(response) {
            this.documentoJsonData = response.data.data;
            this.init();
        },
        calcolaDocumentoRigaDocumentoError(error) {
            error;
        },
        loadData() {
            UtilityMixin.methods.loadDataResources(this.pathResource + "/" + this.id, {}, this.loadDataSuccess, this.loadDataError);
        },
        loadDataSuccess(response) {
            this.contabilitaSetJsonData(response.data.data);
            this.init();
        },
        loadDataError(error) {
            console.log(error);

        },

        loadDataCausale(idCausale) {
            UtilityMixin.methods.loadDataResources(this.pathResourceContabilitaCausaleDocumento + idCausale, {}, this.loadDataCausaleSuccess, this.loadDataCausaleError);
        },
        loadDataCausaleSuccess(response) {
            this.causaleSelezionata = response.data.data;
            this.isBtnDocumentiCollegatiVisibile = this.causaleSelezionata.documentiCollegati.length > 0;
        },
        loadDataCausaleError(error) {
            console.log(error);
        },
        onUpdateDocumentiRiferimento(jsonData) {
            console.log("rif doc", jsonData);
        },
    },
};
</script>
<style scoped>
.sa-documento-meta-wrapper {
    display: flex;
    align-items: center;
    width: 100%;
}

.sa-documento-meta-item {
    display: flex;
    align-items: center;
    gap: 10px;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    padding: 8px 16px;
    border-radius: 8px;
    margin: 4px 4px;
    gap: 16px;
}

.sa-documento-meta-icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 6px;
    font-size: 0.85rem;
}

.sa-documento-meta-icon-wrapper.create {
    background-color: #ecfdf5;
    color: #10b981;
}

.sa-documento-meta-icon-wrapper.update {
    background-color: #eff6ff;
    color: #3b82f6;
}

.sa-documento-meta-text {
    display: flex;
    flex-direction: column;
}

.sa-documento-meta-label {
    font-size: 0.65rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: #64748b;
    line-height: 1;
    margin-bottom: 2px;
}

.sa-documento-meta-date {
    font-size: 0.85rem;
    color: #1e293b;
    font-weight: 600;
}
</style>
